/**
 * Episode Container Component
 * Episode controller.
 */

/* Webpack require dependencies */
var episodes = [];
episodes.push(require('json!../constants/episode-1.json'));
episodes.push(require('json!../constants/episode-2.json'));
episodes.push(require('json!../constants/episode-3.json'));
episodes.push(require('json!../constants/episode-4.json'));
episodes.push(require('json!../constants/episode-5.json'));
episodes.push(require('json!../constants/episode-6.json'));
episodes.push(require('json!../constants/episode-7.json'));
episodes.push(require('json!../constants/episode-8.json'));
episodes.push(require('json!../constants/episode-9.json'));
episodes.push(require('json!../constants/episode-10.json'));
episodes.push(require('json!../constants/episode-11.json'));
episodes.push(require('json!../constants/episode-12.json'));
episodes.push(require('json!../constants/episode-13.json'));
episodes.push(require('json!../constants/episode-14.json'));
episodes.push(require('json!../constants/episode-15.json'));
episodes.push(require('json!../constants/episode-16.json'));
episodes.push(require('json!../constants/episode-17.json'));
episodes.push(require('json!../constants/episode-18.json'));
episodes.push(require('json!../constants/episode-19.json'));
episodes.push(require('json!../constants/episode-20.json'));

import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';

import store from '../store';
import actions from '../actions/episodeActions';
import quizzActions from '../actions/quizzActions';

import EpisodeInfo from './EpisodeInfo';
import Gallery from './GalleryContainer';
import Menu from './Menu';
import Quizz from './Quizz';
import BD from './BD';
import RiskAndSensation from './riskAndSensation/RiskAndSensation';

// Every time the state changes, log it
// Note that subscribe() returns a function for unregistering the listener

class EpisodeContainerComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    store.dispatch(actions.EPISODE_ADD(parseInt(this.episodeId), episodes[parseInt(this.episodeId)]));
    store.dispatch(quizzActions.QUIZZ_CREATE(parseInt(this.episodeId)));
    for(var i=0; i<episodes.length; i++){
      for(var j=0; j<episodes[i].quizz.questions.length; j++){
        episodes[i].quizz.questions[j].answers = this.shuffleArray( episodes[i].quizz.questions[j].answers );
      }
    }
  }

  /**
   * Shuffles array in place.
   * @param {Array} a items The array containing the items.
   */
  shuffleArray (a) {
    var j, x, i;
    if(a){
      for (i = a.length; i; i--) {
        j = Math.floor(Math.random() * i);
        x = a[i - 1];
        a[i - 1] = a[j];
        a[j] = x;
      }
    }
    return a;
  }

  componentWillUpdate(nextProps) {
    if (nextProps.params.episodeId && nextProps.params.episodeId != this.props.episodeId) {
      store.dispatch(actions.EPISODE_UPDATE_CURRENT(parseInt(nextProps.params.episodeId)));
    }
  }

  get episodeId() {
    if (this.props.params.episodeId && this.props.params.episodeId != this.props.episodeId) {
      return parseInt(this.props.params.episodeId);
    }else{
      return parseInt(this.props.episodeId);
    }
  }

  get data() {
    return episodes[this.episodeId-1] || {};
  }

  get prevEpisodeId() {
    return (this.episodeId-1 > 0) ? this.episodeId-1 : null;
  }

  get nextEpisodeId() {
    return (this.episodeId+1 <= this.props.total) ? this.episodeId+1 : null;
  }

  render() {

    document.title = this.data.title
    var _this=this;
    window.MenuInstance.updateMenu();
    // called when component is rendered
    return (
      <div className="episode-component" style={{
          backgroundImage: 'url('+this.data.cover+'), url('+this.data.bg_texture+')',
          backgroundRepeat: 'no-repeat, repeat-y',
          backgroundColor: this.data.bgColor
        }} >

        {/* Episode Info */}
        <EpisodeInfo
          data={this.data} />

        <BD
          bg={this.data.bd_url}
          video={this.data.video} />


        <RiskAndSensation pages={this.data.riskSensation} key={"risk:"+this.data.title} episode={this.episodeId}/>

        <Quizz
          quizz={this.data.quizz}
          quizzId={this.episodeId}
           key={"quiz:"+this.data.title}
          />

        <Gallery
          photos={this.data.photos} />

        {/* EpisodeNav */}
        <nav className="episode-nav">
          {(() => {
            if (this.prevEpisodeId) {
              return (<Link className="prev-episode" to={'/episode/'+this.prevEpisodeId} onClick={()=>window.MenuInstance.showSaisonByEpisode(this.prevEpisodeId)}><span className="arrow"></span> Épisode précédent</Link>)
            }
          })()}

          {(() => {
            if (this.nextEpisodeId) {
              return (<Link className="next-episode" to={'/episode/'+this.nextEpisodeId} onClick={()=>window.MenuInstance.showSaisonByEpisode(this.nextEpisodeId)}>Épisode suivant <span className="arrow"></span></Link>)
            }
          })()}
        </nav>

      </div>
    );
  }
}

EpisodeContainerComponent.propTypes = {};

EpisodeContainerComponent.defaultProps = {};

const mapStateToProps = function(store){
  return {
    episodeId: store.episodes.currentEpisodeId,
    total: store.episodes.total
  }
}

export default connect(mapStateToProps)(EpisodeContainerComponent);



// WEBPACK FOOTER //
// ./src/components/EpisodeContainer.js